import React, { useEffect, useState } from "react";
import { Card, Table, Button, Space, message, Modal } from "antd";
import { Dropdown } from "antd";
import { DeleteOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import { isArrayNonEmpty, isValidElement } from "../../util/ApiHelper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { BASE_API_CONFIG, axiosInstance } from "../../util/Api";
import ListEmptyComponent from "../../components/ListEmptyComponent/ListEmptyComponent";
import SubscriptionPlans from "./../subscriptionPlan/subscriptionPlan";

let navigateToDetails, onPromotionDelete;
const formatDate = (createdAt) => {
  return new Date(createdAt).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const columns = [
  {
    title: "Promotion Title",
    key: "Title",
    render: (record) => <div>{record?.title}</div>,
  },
    {
    title: "Product Category",
    key: "ProductCategory",
    render: (record) => <div>{record?.categories?.name?.replace(/\.$/,"")}</div>,
  },
  {
    title: "Promotion Start",
    key: "Promotion Start",
    render: (record) => <div>{formatDate(record?.startDate)}</div>,
  },
  {
    title: "Promotion End",
    key: "Promotion End",
    render: (record) => <div>{formatDate(record?.endDate)}</div>,
  },

  {
    title: "Actions",
    key: "actions",
    render: (record) => (
      <div className="myexim-action-icon" onClick={(e) => e.stopPropagation()}>
        <Dropdown
          menu={{
            items: [
              {
                label: "View Details",
                key: "1",
                icon: <EyeOutlined />,
                onClick: () => {
                  navigateToDetails(record?.id);
                },
              },
              {
                label: "Delete",
                key: "2",
                icon: <DeleteOutlined />,
                onClick: () => {
                  onPromotionDelete(record?.id);
                },
              },
            ],
          }}
          trigger={["click"]}
        >
          <Space>
            <MoreOutlined />
          </Space>
        </Dropdown>
      </div>
    ),
  },
];

const PromotionsList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector(({ common }) => common);
  const userSubscription = useSelector((state) => state.auth?.userData?.subscription);
  const SubscriptionPlanId = userSubscription?.planId; // Add optional chaining
  console.log("SubscriptionPlanId",userSubscription)
    const userData = useSelector(({ auth }) => auth?.userData);
const authUser = useSelector(({ auth }) => auth.userData);
const userId=userData.id;
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  console.log("setSubscriptionData",subscriptionData?.subscription?.planId)
  const PlanId=subscriptionData?.subscription?.planId;
  const PlanIds =PlanId || 2||3;
  console.log("setSubscriptionData",PlanIds)

  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        dispatch(fetchStart()); // Use Redux action instead of local state
        const response = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
        );
        console.log('Subscription API Response:', response);
        setSubscriptionData(response.data);
        console.log('Subscription API Response check-->002:', response.data?.subscription?.planId);

        
        if (!response.data.isActive) {
          setShowSubscriptionPlans(true);
        }
      } catch (err) {
        setError(err.message);
        console.error('Subscription fetch error:', err);
      } finally {
        dispatch(fetchSuccess());
      }
    };
  
    fetchSubscription();
  }, [userId, dispatch]);

  useEffect(() => {
    fetchPromotions();
  }, [dispatch]);

  const [PromotionsData, setPromotionsData] = useState(null);

  const onShowSizeChange = (current, pageSize) => {};

  const fetchPromotions = async () => {
    try {
      dispatch(fetchStart());
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/promotions?page=1&limit=10`
      );
      const prom = response?.data?.data;
      setPromotionsData(prom.rows);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    } finally {
      dispatch(fetchSuccess());
    }
  };
  console.log(PromotionsData);
  onPromotionDelete = (id) => {
    deleteById(id);
  };

  const deleteById = async (id) => {
    try {
      const response = await axiosInstance.delete(
        `${BASE_API_CONFIG.baseURL}/promotions/${id}`
      );
      if (response.status === 200) {
        message.success("success", "Promotion deleted");
        await fetchPromotions();
      } else {
        message.error("error", "Failed to delete promotion");
      }
    } catch (error) {
      console.error("Error deleting promotions:", error);
    }
  };

  navigateToDetails = (id) => {
    if (isValidElement(id)) {
      history.push(`promotions/view?id=${id}`);
    } else {
      history?.push("promotions/add-edit");
    }
  };
  const handleCreatePromotion = () => {
    const currentPlanId = subscriptionData?.subscription?.planId;
    if (currentPlanId === 2 || currentPlanId === 3) {
      navigateToDetails();
    } else {
      setShowSubscriptionPlans(true);
      message.warning("You need a Subscription  Basic Plan  or Premium Plan to create promotions.");
    }
  };
  return (
    <Card
      title={
        <div style={{ display: "flex" }}>
          <div className="myexim-table-title">Promotions</div>
          <div style={{ paddingLeft: 15 }}>
            <Button type="primary" 
            onClick={handleCreatePromotion}
            >
              + Create Promotion
            </Button>
          </div>
        </div>
      }
    >
      <div>
        <div className="myexim-table-header">
          {/* <div>
              <Input
                placeholder="Search Promotions"
                size="large"
                onChange={onSearch}
                suffix={<SearchOutlined />}
                onPressEnter={(e) => onSearch(e.target.value)}
              />
            </div> */}
          {/* <div>
            <Button type="primary" onClick={() => navigateToDetails()}>
              Add New Promotion
            </Button>
          </div> */}
        </div>
        {isArrayNonEmpty(PromotionsData) ? (
          <Table
            rowClassName={(record, index) =>
              index % 2 === 0 ? "table-row-light" : "table-row-dark"
            }
            onRow={(record) => {
              return {
                onClick: (e) => {
                  if (
                    !e.target.classList.contains(
                      "ant-dropdown-menu-title-content"
                    )
                  ) {
                    navigateToDetails(record?.id);
                  }
                },
              };
            }}
            className="gx-table-responsive my-product-table myexim-table"
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={PromotionsData}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              pageSize: 10,
              total: PromotionsData?.count,
              onChange: onShowSizeChange,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        ) : (
          !loading && (
            <ListEmptyComponent
              message="No Promotions available"
              onButtonClick={() => navigateToDetails()}
            />
          )
        )}
      </div>

      <Modal
      open={showSubscriptionPlans}
      onCancel={() => setShowSubscriptionPlans(false)}
      footer={null}
      width={800}
    >
      <SubscriptionPlans 
        userDatas={authUser}
        setUserDatas={(updatedUser) => {
          setSubscriptionData(updatedUser.subscription);
          setShowSubscriptionPlans(false);
        }}
      />
    </Modal>
    </Card>
  );
};

export default PromotionsList;
